/*@ngInject*/
const GrowlController = function ($element, $rootScope, $state, $stateParams, coreMediator, notificationType, submissionStateMediator, submissionConstant, preferenceModel) {

    const openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
    const openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);

    $element.addClass('uiGrowlNotification');

    this.onGrowlClick = function () {
        // acknowledge the notification and route to the associated submission
        const params = {
            submissionId: this.notification.submissionId
        };
        const stateName = 'submission.form';

        coreMediator.acknowledgeByNotificationId(this.notification.id).then(() => {
            if (openingSubmissionFromNotificationMarksNotificationAsRead) {
                coreMediator.markAsReadByNotificationId(this.notification.id, true);
            }
        });

        if (_.isNil($stateParams.submissionId) || parseInt($stateParams.submissionId) !== this.notification.submissionId) {
            if (this.notification.type === notificationType.CHAT) {
                submissionStateMediator.openChatCollaboration(this.notification.submissionId);
            }
            $state.go(stateName, params);
        } else {
            if (this.notification.type === notificationType.CHAT) {
                $rootScope.$broadcast(submissionConstant.event.OPEN_CHAT_COLLABORATION);
            }
        }
    };

    this.onDismissGrowl = function (event) {
        // prevent propagation to the onGrowlClick() function
        event.stopPropagation();
        event.preventDefault();
        // call the bound function to close the notification
        this.closeNotification();
        return false;
    };

    this.getNotificationMessage = function () {
        const actorName = this.notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : this.notification.actorName;
        return `<strong>${actorName}</strong> ${this.notification.message}`;
    };
};

angular.module('umCore')
    .controller('growlController', GrowlController);
